import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import PageLoader from "../../../shared/PageLoader";
import { useBulkReviewCompliances } from "../../../../backend/compliance";
import { ComplianceActivityStatus, ComplianceStatusMapping } from "../../../../constants/Compliance.constants";

const REVIEWABLE_STATUSES = [ComplianceActivityStatus.PENDING];

function ComplianceBulkReviewModal({ onClose, selectedItems }: any) {
    const [status, setStatus] = useState('');
    const [auditRemarks, setAuditRemarks] = useState('');

    const { bulkReviewCompliances, reviewing } = useBulkReviewCompliances(
        (response: any) => {
            onClose(true);
            const failed = ((response || {}).data || {}).failed || [];
            if (failed.length > 0) {
                toast.warning(`${failed.length} compliance record(s) could not be updated.`);
            }
            toast.success(
                status === ComplianceActivityStatus.APPROVED
                    ? "Compliances approved successfully."
                    : "Compliances rejected successfully."
            );
        },
        (error: any) => {
            const data = (error && error.response && error.response.data) || {};
            toast.error(data.error || data.message || "Bulk review failed.");
        }
    );

    function clearAll() {
        setStatus('');
        setAuditRemarks('');
    }

    function handleSubmit() {
        const eligibleItems = (selectedItems || []).filter((item: any) => REVIEWABLE_STATUSES.includes(item.status));
        if (eligibleItems.length === 0) {
            toast.warning("None of the selected compliances are in Submitted status for review.");
            return;
        }
        bulkReviewCompliances({
            compliance_ids: eligibleItems.map((item: any) => item.id),
            status,
            audit_remarks: auditRemarks.trim()
        });
    }

    const canSubmit = Boolean(status) && Boolean(auditRemarks.trim());

    return (
        <>
            <Modal show={true} backdrop="static" animation={false} size="lg" centered={true}>
                <Modal.Header closeButton={true} onHide={() => onClose()}>
                    <Modal.Title className="bg">Bulk Review</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <label className="form-label fw-medium">Compliance Status<span className="text-danger"> *</span></label>
                        <select
                            className="form-select"
                            style={{ maxWidth: 280 }}
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                        >
                            <option value="">Select Compliance Status</option>
                            <option value={ComplianceActivityStatus.APPROVED}>{ComplianceStatusMapping[ComplianceActivityStatus.APPROVED]}</option>
                            <option value={ComplianceActivityStatus.REJECTED}>{ComplianceStatusMapping[ComplianceActivityStatus.REJECTED]}</option>
                        </select>
                    </div>

                    <div className="mb-3">
                        <label className="form-label fw-medium">Remarks<span className="text-danger"> *</span></label>
                        <textarea
                            className="form-control"
                            rows={3}
                            style={{ resize: "vertical" }}
                            placeholder="Enter Remarks"
                            value={auditRemarks}
                            onChange={(e) => setAuditRemarks(e.target.value)}
                        />
                    </div>

                    <p className="text-muted mb-0" style={{ fontSize: 13 }}>
                        Compliances which are in Submitted status only will get Reviewed
                    </p>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-between">
                    <Button variant="outline-secondary" onClick={() => onClose()}>Back</Button>
                    <div className="d-flex gap-2">
                        <Button variant="light" onClick={clearAll}>Reset</Button>
                        <Button variant="primary" onClick={handleSubmit} disabled={!canSubmit}>Submit</Button>
                    </div>
                </Modal.Footer>
            </Modal>
            {reviewing && <PageLoader />}
        </>
    );
}

export default ComplianceBulkReviewModal;
